import { IAppState } from '../context/Context'
import { Views } from '../../enums'
import { TCF } from '../../../../cmp/tcf/TCF'

export namespace Settings {
  export const reducer = (prevState: IAppState): IAppState => {
    TCF.consentDoesApply({ displayUi: true })
    return {
      ...prevState,
      view: Views.default
    }
  }
}
